import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComboChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.2474 26.8346H1.7474C1.4254 26.8346 1.16406 26.5733 1.16406 26.2513V19.2513C1.16406 18.9293 1.4254 18.668 1.7474 18.668H5.2474C5.5694 18.668 5.83073 18.9293 5.83073 19.2513V26.2513C5.83073 26.5733 5.5694 26.8346 5.2474 26.8346ZM2.33073 25.668H4.66406V19.8346H2.33073V25.668Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2474 26.832H8.7474C8.4254 26.832 8.16406 26.5707 8.16406 26.2487V13.4154C8.16406 13.0934 8.4254 12.832 8.7474 12.832H12.2474C12.5694 12.832 12.8307 13.0934 12.8307 13.4154V26.2487C12.8307 26.5707 12.5694 26.832 12.2474 26.832ZM9.33073 25.6654H11.6641V13.9987H9.33073V25.6654Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2474 26.8346H15.7474C15.4254 26.8346 15.1641 26.5733 15.1641 26.2513V15.7513C15.1641 15.4293 15.4254 15.168 15.7474 15.168H19.2474C19.5694 15.168 19.8307 15.4293 19.8307 15.7513V26.2513C19.8307 26.5733 19.5694 26.8346 19.2474 26.8346ZM16.3307 25.668H18.6641V16.3346H16.3307V25.668Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.2474 26.8346H22.7474C22.4254 26.8346 22.1641 26.5733 22.1641 26.2513V8.7513C22.1641 8.4293 22.4254 8.16797 22.7474 8.16797H26.2474C26.5694 8.16797 26.8307 8.4293 26.8307 8.7513V26.2513C26.8307 26.5733 26.5694 26.8346 26.2474 26.8346ZM23.3307 25.668H25.6641V9.33464H23.3307V25.668Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.20312 13.8981L9.09152 6.53656C9.4739 6.05853 10.1607 5.95732 10.6647 6.30475L16.5555 10.3654C17.0628 10.7151 17.7547 10.61 18.1352 10.1253L24.5483 1.95703",
			stroke: "currentColor",
			strokeWidth: 1.16667,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgComboChart;
